import { init as lazyInit } from './amp-lazy-tool.js';
import { init as lazyBranchInit, hideBranches as resetAll } from './amp-branch-leaflet-lazy-tool.js';

lazyInit(lazyBranchReinit);
lazyBranchInit();

export function lazyBranchReinit()
{
    lazyBranchInit();
    resetAll();
}